import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";

import axios from "../../helpers/axios";
import { PartStatusList } from "../../helpers/parts";

const InvoiceEditor = ({ value, setValue }) => {
  const loadOptions = (inputValue, callback) => {
    axios.get("/api/invoices/").then(({ data }) => {
      const { results } = data;
      const response = results
        .map((r) => ({ label: `${r.id} - ${r.name}`, value: r.id }))
        .filter((r) => r.label.toLowerCase().includes(inputValue));

      callback(response);
    });
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions
      value={value}
      onChange={(pair) => setValue(pair.value)}
    />
  );
};

const PartStatusEditor = ({ value, setValue }) => (
  <div className="select is-fullwidth">
    <select value={value} onChange={(event) => setValue(event.target.value)}>
      {PartStatusList.map((status) => (
        <option key={status.id} value={status.id}>
          {status.key}
        </option>
      ))}
    </select>
  </div>
);

const CurrencyEditor = ({ value, setValue }) => {
  const [currency, setCurrency] = useState("");
  const [ammount, setAmmount] = useState("");

  useEffect(() => {
    if (value === "") {
      setCurrency("");
      setAmmount("");
    }
  }, [value]);

  useEffect(() => {
    // set value
    setValue(`${currency} ${ammount}`);
  }, [currency, ammount]);

  return (
    <div class="field has-addons">
      <p class="control">
        <span class="select">
          <select value={currency} onChange={(event) => setCurrency(event.target.value)}>
            <option>Selecione moneda</option>
            <option value="MXN">MXN</option>
            <option value="USD">USD</option>
          </select>
        </span>
      </p>
      <p class="control is-expanded">
        <input class="input" type="text" placeholder="Amount of money"  value={ammount} onChange={(event) => setAmmount(event.target.value)}/>
      </p>
    </div>
  );
}

const InputEditor = ({ type, value, setValue }) => (
  <input
    type={type}
    className="input"
    value={value}
    onChange={(event) => setValue(event.target.value)}
  />
);

const FieldEditorProvider = (props) => {
  if (props.type === "invoice") {
    return <InvoiceEditor {...props} />;
  }

  if (props.type === "currency") {
    return <CurrencyEditor {...props}/>;
  }

  if (props.type === "part-status") {
    return <PartStatusEditor {...props} />;
  }

  return <InputEditor {...props} />;
};

export { InputEditor, PartStatusEditor, InvoiceEditor, CurrencyEditor };
export default FieldEditorProvider;
